module.exports = __webpack_public_path__ + "img/parcelamento.fa268e78.png";